import styled from 'styled-components'

import { ButtonProps } from '../../../domain/documents.types'
import { DocumentCategoryLabel } from '../../../domain/enums/documents.enum'

export const Title = styled.div`
  padding: 1rem 0;
  color: ${(props) => props.theme.colors.white};
  font-size: ${(props) => props.theme.sizes.h1};
  font-weight: 700;
  & span {
    font-weight: 300;
  }
`
export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 1rem;
`

export const BaseButton = styled.button`
  padding: 0.5rem;
  border: none;
  outline: none;
  background-color: ${(props) => props.theme.colors.transparent};
  color: ${(props) => props.theme.colors.whiteAlpha40};
  &:hover {
    color: ${(props) => props.theme.colors.primaryColor500};
  }
  &:disabled {
    color: ${(props) => props.theme.colors.whiteAlpha10};
  }
  flex: 0;
  font-size: 1rem;
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
`

export const TriggerButton = styled(BaseButton)<ButtonProps>`
  color: ${(props) =>
    props.isOpen ? props.theme.colors.primaryColor500 : props.theme.colors.whiteAlpha40};
`

export const ModalOverlay = styled.div`
  position: absolute;
  background: ${(props) => (props.theme.isMobile ? props.theme.colors.blackAlpha50 : 'unset')};
  width: ${(props) => (props.theme.isMobile ? '100%' : 'unset')};
  height: ${(props) => (props.theme.isMobile ? '100%' : 'unset')};
  right: ${(props) => (props.theme.isMobile ? '0' : '1rem')};
  top: ${(props) => (props.theme.isMobile ? '0' : '5rem')};
  z-index: ${(props) => (props.theme.isMobile ? '99999' : 'unset')};
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background: ${(props) => props.theme.gradient.cardBackground};
  border-radius: ${(props) => (props.theme.isMobile ? '0 0 6px 6px' : '6px')};
`

export const FilterLabel = styled.span`
  font-size: 1rem;
  font-weight: 200;
  margin-left: 0.5rem;
`
export const DocumentWrapper = styled.div`
  width: 100%;
  padding: 1rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.theme.isMobile ? '6vh' : 'unset')};
`
export const DocumentList = styled.div`
  padding: 1rem 0;
  display: flex;
  flex: 1;
`

interface StyledCategoryProps {
  color: DocumentCategoryLabel
  fontSize?: string
  width?: string
}

export const StyledCategory = styled.div<StyledCategoryProps>`
  border-radius: 4px;
  padding: 0.5rem;
  font-size: ${(props) => props.fontSize || '1rem'};
  width: ${(props) => props.width || ''};
  background-color: ${(props) => {
    switch (props.color) {
      case DocumentCategoryLabel.PRODUCTION:
        return props.theme.colors.carefulColor100
      case DocumentCategoryLabel.INTERVENTION:
        return props.theme.colors.secondaryColor100
      default:
        return props.theme.colors.secondaryColor500
    }
  }};

  color: ${(props) => {
    switch (props.color) {
      case DocumentCategoryLabel.PRODUCTION:
        return props.theme.colors.carefulColor700
      case DocumentCategoryLabel.INTERVENTION:
        return props.theme.colors.secondaryColor700
      default:
        return props.theme.colors.neutralColor700
    }
  }};
`
export const DocumentsListMobileWrapper = styled.div`
  width: 100%;
  flex-direction: column;
  color: ${(props) => props.theme.colors.white};
  & > div:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`

export const CenterWrapper = styled.div`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  & p {
    padding: 0.5rem;
  }
`

export const ViewButton = styled.button`
  background-color: transparent;
  border: none;
  color: ${(props) => props.theme.colors.whiteAlpha40};
  cursor: pointer;
  border-radius: 4px;
  &:hover {
    color: ${(props) => props.theme.colors.primaryColor500};
  }
  &:focus {
    outline: none;
    background-color: ${(props) => props.theme.colors.neutralColor500};
  }
  &:disabled {
    cursor: default;
    background-color: transparent;
    &:hover {
      color: ${(props) => props.theme.colors.whiteAlpha20};
    }
  }
`

export const Element = styled.div`
  padding: 0.5rem;
  color: ${(props) => props.theme.colors.whiteAlpha40};
  font-size: ${(props) => props.theme.sizes.h5};
  justify-content: center;
  flex-direction: column;
`

export const Name = styled.div`
  color: ${(props) => props.theme.colors.white};
  word-break: break-word;
`

export const StyledDate = styled.div`
  font-size: ${(props) => props.theme.sizes.h6};
`

export const Row = styled.div<{ color: string }>`
  display: flex;
  background: ${(props) => props.theme.gradient.cardBackground};
  box-shadow: ${(props) => props.theme.shadow.main};
  border-radius: 6px;
  color: ${(props) => props.theme.colors.white};
  padding: 0.3rem;
  border-left: 7px solid
    ${(props) => {
      if (props.color === DocumentCategoryLabel.PRODUCTION) {
        return props.theme.colors.carefulColor100
      }
      if (props.color === DocumentCategoryLabel.INTERVENTION) {
        return props.theme.colors.secondaryColor100
      }
      return props.theme.colors.neutralColor100
    }};
`
